module.exports = __webpack_public_path__ + "media/images/project_cache-ed38c0a5e413d8662b9e1a176d1998d1.png";